import BaseService from '../../BaseService';

class SeasonService extends BaseService {
    getAll = (filters) => this.post('/warehouse/product/seasons', filters || { });

    getOne = (id) => this.get(`/warehouse/product/season/${id}`);

    deleteOne = (id) => this.delete(`/warehouse/product/season/${id}`);

    addSeason = (data) => this.post('/warehouse/product/season', data);

    editSeason = (id, data) => this.put(`/warehouse/product/season/${id}`, data);
}

export default new SeasonService();